import React from 'react';
import styled from 'styled-components';

import { Icon, IconHorizontalPoints } from '../../base/icons';
import { ACTION_TRIGGER } from '../constants';

export const ignoredChildClassName = 'ignore-child';

export const AntiCollapse = styled.br`
  font-size: 0;
`;

export const Button = styled.button`
  align-items: center;
  background-color: ${

    props => {
        if (props.primary) {
            return '';
        }

        return '#3D3D3D';
    }
};
  border: 0;
  border-radius: 6px;
  display: flex;
  font-weight: unset;
  justify-content: center;
  min-height: 32px;

  &:hover {
    background-color: ${

    props => {
        if (props.primary) {
            return '';
        }

        return '#525252';
    }
};
  }
`;

export const QuickActionButton = styled(Button)`
  padding: 0 12px;
`;

export const Container = styled.div`
  box-sizing: border-box;
  flex: 1;
  overflow-y: auto;
  position: relative;
  padding: ${props => props.theme.panePadding}px;

  & > * + *:not(.${ignoredChildClassName}) {
    margin-top: 16px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  background: white;
  border: 2px solid #c7d5e9;
  border-radius: 0 0 20px 20px;
`;

export const ContextMenu = styled.div.attrs(props => {
    return {
        className: props.className
    };
})`
  background-color: #292929 !important;
  border-radius: 3px;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.6),
    0px 0px 4px 1px rgba(0, 0, 0, 0.25);
  color: white;
  font-size: ${props => props.theme.contextFontSize}px;
  font-weight: ${props => props.theme.contextFontWeight};
  margin-top: ${props => {
        const { participantActionButtonHeight, participantItemHeight }
      = props.theme;

        return ((3 * participantItemHeight) + participantActionButtonHeight) / 4;
    }}px;
  position: absolute;
  overflow-y: scroll;
  height: 360px;

  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #0000000f;
  border: 2px solid #c7d5e9;
  border-radius: 16px;
  opacity: 1;

  right: ${props => props.theme.panePadding}px;
  top: 0;
  z-index: 2;

  & > li {
    list-style: none;
  }

  ${props =>
        props.isHidden
    && `
    pointer-events: none;
    visibility: hidden;
  `}
`;

export const ContextMenuIcon = styled(Icon).attrs({
    size: 20
})`
  & > svg path {
    ${props => props.fillColor && `fill: ${props.fillColor} !important;`};
    ${props => props.strokeColor && `stroke: ${props.strokeColor} !important;`};
  };
`;

export const ModeratorLabel = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #858585;
  text-align: left;
  font: normal normal 600 12px/19px Manrope;
  letter-spacing: 0.5px;
  color: #292929;
  opacity: 1;
`;

export const ParticipantDetailsContainer = styled.div`
  display: flex;
  flex: 1;
  margin-right: 8px;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  ${props => props.width && `width: ${props.width}px;`}
`;

export const ContextMenuItem = styled.div`
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  min-height: 40px;
  ${props => props.color && `color: ${props.color} !important;`}
  ${props => props.background && `background: ${props.background} !important;`}
  font: normal normal medium 18px/22px Manrope;
  padding: 8px 16px;
  letter-spacing: 0.56px;
  margin-bottom: 5px;
  border-radius: 10px;
  pointer-events: ${props => props.disable};
  & > *:not(:last-child) {
    margin-right: 16px;
  }

  &span {
    color: ${props => props.color && `${props.color} !important`};
  }

  // &:hover {
  //   background-color: #525252;
  // }
`;

export const ContextMenuItemGroup = styled.div`
  ${props => props.background && `background: ${props.background} !important;`}
  &:not(:empty) {
    padding: 8px 0;
  }

  & + &:not(:empty) {
    border-top: 1px solid #4c4d50;
  }
`;

export const Close = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;

  &:before,
  &:after {
    content: "";
    background-color: #a4b8d1;
    border-radius: 2px;
    height: 2px;
    position: absolute;
    transform-origin: center center;
    width: 21px;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

export const Footer = styled.div`
  background-color: #233b4f !important;
  display: flex;
  justify-content: flex-end;
  padding: 24px ${props => props.theme.panePadding}px;

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

export const FooterButton = styled(Button)`
  // height: 40px;
  // font-size: 15px;
  // padding: 0 16px;
`;

export const FooterEllipsisButton = styled(FooterButton).attrs({
    children: <Icon src = { IconHorizontalPoints } />
})`
  // padding: 8px;
`;

export const FooterEllipsisContainer = styled.div`
  position: relative;
`;

export const Header = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: ${props => props.theme.headerSize}px;
  padding: 0 20px;
  width: 100%;
  height: 65px;
  /* UI Properties */
  background: #4b6790 0% 0% no-repeat padding-box;
  border: 1px solid #4b6790;
  border-radius: 20px 20px 0px 0px;
  opacity: 1;
  background: ${props => props.theme.headerBackground};
`;

export const Heading = styled.div`
  display: 'flex';
  width: '100%';
  justifyContent: 'space-between';
`;

export const ColoredIcon = styled.div`
  & > div > svg {
    fill: ${props => props.color || '#fff'} !important;
  }
`;

export const ParticipantActionButton = styled(Button)`
  height: ${props => props.theme.participantActionButtonHeight}px;
  padding: 6px 10px;
`;

export const ParticipantActionEllipsis = styled(ParticipantActionButton).attrs({
    children: <Icon src = { IconHorizontalPoints } />,
    primary: true
})`
  background: white;
  padding: 0px;
`;

export const ParticipantActions = styled.div`
  align-items: center;
  z-index: 1;

  & > *:not(:last-child) {
    // margin-right: 8px;
  }
`;

export const ParticipantActionsHover = styled(ParticipantActions)`
  bottom: 1px;
  display: none;
  position: absolute;
  width: 10px !important;
  right: ${props => props.theme.panePadding};
  top: 0;

  &:after {
    content: "";
    // background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #292929 100%);
    bottom: 0;
    display: block;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transform: translateX(-100%);
    width: 40px;
  }
`;

export const ParticipantActionsPermanent = styled(ParticipantActions)`
  display: flex;
`;

export const ParticipantContent = styled.div`
  align-items: center;
  box-shadow: inset 0px -1px 0px rgba(255, 255, 255, 0.15);
  display: flex;
  flex: 1;
  height: 100%;
  padding-right: ${props => props.theme.panePadding}px;
`;

export const ParticipantContainer = styled.div`
  align-items: center;
  color: white;
  display: flex;
  font-size: 13px;
  height: ${props => props.theme.participantItemHeight}px;
  margin: 0 -${props => props.theme.panePadding}px;
  padding-left: ${props => props.theme.panePadding}px;
  position: relative;
  ${props => props.isPinned && 'border: 2px solid #1acc8d !important;'}
  ${props => props.isLastParticipant && 'margin-bottom: 22px !important;'}
  ${props => !props.isHighlighted && '&:hover {'}
  // background-color: #292929;

    & ${ParticipantActions} {
    ${props =>
        props.trigger === ACTION_TRIGGER.HOVER
    && `
        display: flex;
      `}
  }

  & ${ParticipantContent} {
    box-shadow: none;
  }
  ${props => !props.isHighlighted && '}'}
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #b5cbeb;
  border-radius: 8px;
  margin: 5px 0px;
  opacity: 1;
`;

export const ParticipantInviteButton = styled(Button).attrs({
    primary: true
})`
  font-size: 15px;
  height: 40px;
  width: 100%;
  background: #4b6790 0% 0% no-repeat padding-box;
  border-radius: 8px;
  height: 54px;
  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const SearchParticipantInput = styled.input`
  // background-color: #3D3D3D;
  // background: #3D3D3D;
  color: black;
  padding: 10px 16px;
  // border-radius: 6px;
  border: 0;
  height: 40px;
  box-sizing: border-box;
  width: 100%;
  font-size: 14px;
  text-align: left;
  font: normal normal normal 14px/17px Manrope;
  letter-spacing: 0.44px;
  color: #c6c6c6;
  opacity: 1;

  ::placeholder {
    color: #858585;
  }

  &:focus {
    outline: 0;
    box-shadow: 0px 0px 0px 2px #4b6790;
  }

  &:disabled {
    color: #858585;
  }

  // &.icon-input {
  //     padding-left: 46px;
  // },

  // &.error {
  //     box-shadow: 0px 0px 0px 2px #F24D5F;
  // }
  background: #f8f8f8 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
`;

export const ParticipantName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`;

export const ParticipantNameContainer = styled.div`
  display: flex;
  flex: 1;
  margin-right: 8px;
  overflow: hidden;
  text-align: left;
  font: normal normal 600 12px/19px Manrope;
  letter-spacing: 0.5px;
  color: #292929;
  opacity: 1;
`;

export const ParticipantStates = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  & > * {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const RaisedHandIndicatorBackground = styled.div`
  background-color: rgb(228, 235, 245);
  border-radius: 50px;
  height: 28px;
  width: 28px;
`;

export const VolumeInput = styled.input.attrs({
    type: 'range'
})`
  width: 100%;
`;

export const VolumeInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const VolumeOverlay = styled.div`
  background-color: #0376da;
  border-radius: 1px 0 0 1px;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
`;
